<template>
  <div>
    <ReactWrapper :react-component="reactComponent" />
  </div>
</template>

<script lang="ts">
import ProfileMenu from "@iloq/shared-react/profile-menu/ProfileMenu";
import { defineComponent } from "vue";
import ReactWrapper from "../util/ReactWrapper.vue";

export default defineComponent({
  name: "ProfileMenuConnector",
  components: {
    ReactWrapper,
  },
  data: function () {
    return {
      reactComponent: ProfileMenu,
    };
  },
});
</script>

<style lang="scss"></style>
